import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=7768edea&scoped=true&"
import script from "./staking.vue?vue&type=script&lang=ts&"
export * from "./staking.vue?vue&type=script&lang=ts&"
import style0 from "./staking.vue?vue&type=style&index=0&id=7768edea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7768edea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VRow,VSheet})
